import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api } from 'src/api.config';
import { Role } from '../models/role';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class RoleService extends BaseService {

  constructor(private http: HttpClient) {
    super();
  }

  public listRoles() {
    let resource = `${this.apiUrl}/${api.v1.roles}`
    return this.http.get<Role[]>(resource);
  }

  
}
